import React, { useContext } from 'react'
import { useField } from 'formik'

import { Checkbox, styled } from 'tamagui'

import { FormFieldContext } from './shared'
import FluentCheckmarkFilled from '../Icon/icons/CheckmarkFilledIcon'

const StyledCheckbox = styled(Checkbox, {
  borderColor: '$borderColor',
  borderRadius: '$1',
  width: '$5',
  height: '$5',
  padding: '$1',

  variants: {
    size: {
      '...size': () => ({}),
    },
  } as const,
})

export const FormCheckbox = StyledCheckbox.styleable((props, ref) => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, , helpers] = useField(formFieldContext.name)

  return (
    <StyledCheckbox
      ref={ref}
      size='$5'
      {...props}
      disabled={props.disabled ?? false}
      checked={!!field.value}
      onCheckedChange={(checked: boolean) => {
        void helpers.setValue(checked)

        if (props.onCheckedChange) {
          props.onCheckedChange(checked)
        }
      }}
    >
      <Checkbox.Indicator>
        <FluentCheckmarkFilled width={16} height={16} />
      </Checkbox.Indicator>
    </StyledCheckbox>
  )
})
